import React, { memo } from 'react';
import dayjs from 'app/libs/dayjs';
import useCars from 'app/hook/cars/useCars';
import { numberWithCommas } from 'app/libs/number';
import classNames from 'classnames/bind';
import styles from './ReportAccidentSummary.module.scss';

const cx = classNames.bind(styles);

function ReportAccidentSummary() {
	const { base, accident } = useCars();
	const changeUseHistory =
		parseInt(accident.loan, 10) + parseInt(accident.business, 10) + parseInt(accident.government, 10) > 0 ? '사용이력있음' : '없음';
	return (
		<>
			<h3 className={cx('blind')}>보험이력</h3>
			<div className={cx('info_car')}>
				<strong className={cx('txt_supply')}>정보조회일 {dayjs(accident.regDate).format('YYYY/MM/DD')}</strong>
			</div>
			<div className={cx('info_summary')}>
				<strong className={cx('tit_info')}>중고차 사고이력 정보 요약</strong>
				<ul className={cx('list_accident')}>
					<li>
						<strong className={cx('tit')}>일반사양</strong>
						<span className={cx('txt')}>
							<span className={cx('comma')}>{accident.maker}</span>
							<span className={cx('comma')}>{base.category.modelName}</span>
							<span className={cx('comma')}>{accident.year}년식</span>
							{accident.carShape && <span className={cx('comma')}>{accident.carShape}</span>}
						</span>
					</li>
					<li>
						<strong className={cx('tit')}>용도 변경이력</strong>
						<span className={cx('txt')}>{changeUseHistory}</span>
					</li>
					<li>
						<strong className={cx('tit')}>번호 / 소유자 변경이력</strong>
						<span className={cx('txt')}>
							<span className={cx('slash')}>{accident.carNoChangeCnt}회</span>
							<span className={cx('slash')}>{accident.ownerChangeCnt}회</span>
						</span>
					</li>
					<li>
						<strong className={cx('tit')}>특수 사고이력</strong>
						<span className={cx('txt')}>
							<span className={cx('slash')}>전손 {accident.totalLossCnt}회</span>
							<span className={cx('slash')}>침수(전손,분손) {accident.floodTotalLossCnt}회</span>
							<span className={cx('slash')}>도난 {accident.robberCnt}회</span>
						</span>
					</li>
					<li>
						<strong className={cx('tit')}>보험사고 이력 (내차 피해)</strong>
						<span className={cx('txt')}>
							{!accident.myAccidentCnt ? (
								<>없음</>
							) : (
								<>
									<span className={cx('slash')}>{accident.myAccidentCnt}회</span>
									<span className={cx('slash')}>
										{!accident.myAccidentCost ? '미확정' : `${numberWithCommas(accident.myAccidentCost)}원`}
									</span>
								</>
							)}
						</span>
					</li>
					<li>
						<strong className={cx('tit')}>보험사고 이력 (타차 가해)</strong>
						<span className={cx('txt')}>
							{!accident.otherAccidentCnt ? (
								<>없음</>
							) : (
								<>
									{accident.otherAccidentCnt}회/
									{!accident.otherAccidentCost ? '미확정' : `${numberWithCommas(accident.otherAccidentCost)}원`}
								</>
							)}
						</span>
					</li>
				</ul>
			</div>
		</>
	);
}

export default memo(ReportAccidentSummary);
